module.exports = __webpack_public_path__ + "static/media/backsplash5.aa0eaec4.jpg";